import React from "react";
import PropTypes from "prop-types";
const SentenceCaseIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title,
  isSelected
}) => {
  const getColor = () => {
    if (isSelected) return "var(--color-easil-black)";
    return color || "var(--color-easil-gray-x-dark)";
  };

  return (
    <svg
      className={className}
      style={style}
      data-no-pointer={noPointer}
      width={width || size || 20}
      height={height || size || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="title"
    >
      <title>{title}</title>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h20v20H0z" />
        <g
          stroke={getColor()}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="m3 11 3-6 3 6M4 9.5h4M12 9h5M3 15h14" />
        </g>
      </g>
    </svg>
  );
};

SentenceCaseIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string,
  title: PropTypes.string,
  isSelected: PropTypes.bool,
  noPointer: PropTypes.bool
};

export default SentenceCaseIcon;
